// extracted by mini-css-extract-plugin
module.exports =  {"root":"DocZx6jGLj3Bz8WbFlxG","sidebarWrapper":"XyNqamRcDuytSZrj_ycv","sidebar":"Bk3CUlByqCCT5BhkWJ5u","navBottom":"QvtpSewnQpr2e3YI_ekO"};